import { Box, Section, Text } from '@factorialco/deprecated-design-system'
import {
  ProjectDetailsPageSettingsPageStatusSectionFragment,
  ProjectManagementProjectStatusEnum,
  ProjectSettingsChangeStatusDocument,
} from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import {
  ProjectStatusForm,
  ProjectStatusValues,
} from 'modules/project_management/components/forms/ProjectStatusForm'
import { StatusActions } from 'modules/project_management/lib/projectStatus'

interface Props {
  project: ProjectDetailsPageSettingsPageStatusSectionFragment
}
export const StatusSection = ({ project }: Props) => {
  const [changeStatus, { loading }] = useMutation(ProjectSettingsChangeStatusDocument, {
    extractorFn: (data) => data.projectManagementMutations.changeStatusProjectmanagementProject,
  })

  const { id: projectId, status } = project

  const { values, setValues, handleSubmit, isValid, dirty } = useForm<ProjectStatusValues>({
    defaultValues: {
      status: status,
    },
    enableReinitialize: true,
    onSubmit: async (data, {}) => {
      const result = await changeStatus({
        variables: {
          id: projectId,
          status: data.status,
        },
      })

      const handled = handleResult(result, () => {})

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
      }

      track(trackingEvents.projectManagement.settings.changeStatus, {
        project_id: projectId,
        status: data.status,
      })

      return handled
    },
  })

  const handleFieldChanged = (newStatus: ProjectManagementProjectStatusEnum) => {
    setValues({ status: newStatus })
  }

  const warningText = () => {
    if (values.status == 'active')
      return i18n.t('project_management.settings.sections.status.warning.active')
    if (values.status == 'draft')
      return i18n.t('project_management.settings.sections.status.warning.draft')
    if (values.status == 'closed')
      return i18n.t('project_management.settings.sections.status.warning.closed')
  }

  return (
    <Section.Form
      illustration="tasks_management"
      title={i18n.t('project_management.settings.sections.status.title')}
      description={i18n.t('project_management.settings.sections.status.description')}
      onSubmit={handleSubmit}
      submitLabel={i18n.t('common.submit')}
      disabled={loading || !isValid}
      isDirty={dirty}
      paddingX="s0"
    >
      <ProjectStatusForm
        values={values}
        onChangeValue={handleFieldChanged}
        action={StatusActions.Update}
      />
      {dirty && warningText() && (
        <Box
          gap="s16"
          padding="s16"
          borderRadius={{
            all: 'abs008',
          }}
          background="champagne400"
        >
          <Text.Normal>{warningText()}</Text.Normal>
        </Box>
      )}
    </Section.Form>
  )
}
